// Core imports
import * as React from 'react';
import i18n from 'src/translation/i18n';
import { commentsRegEx } from 'src/utils/RegexUtils';
import './ReceivedUsedPartMoreInfo.scss';

// utils regex
import { emailcapsRegEx } from 'src/utils/RegexUtils';

class ReceivedUsedPartMoreInfo extends React.Component<IReceivedUsedPartMoreInfoProps, any> {
  constructor(props: IReceivedUsedPartMoreInfoProps) {
    super(props);
  }
 
  public render() {
    return (
      <div style={{ marginBottom: '10px'}}>
        <h4>{i18n.t('warrantyView.moreInfo')}</h4>
        <div className="form-row row  ">

          <div className="form-group col-sm-12 col-md-6 col-lg-12 mb">
              <div>
                  <label>{i18n.t('partClaim.commentUsedPart')}:*</label>
              </div>
              <div className='description-box'>
                <input
                className={`form-control-claims ${
                  this.props.DamageErrormsgshow && this.props.DamageAdditionalComment.trim()===''
                    ? 'form-control-error-border'
                    : ''
                }`}
                name="addtionalComment"
                type="text"
                value={this.props.DamageAdditionalComment}
                onChange={e => this.props.handleAdditionalComment(e)}
              />
                <div>
                    {this.props.DamageErrorlistservice
                      ?.DamageAdditionalCommentError ? (
                        this.props.DamageErrorlistservice === '' ? (
                        <span className="rp-warranty-input-error-internal">
                          {i18n.t('partClaim.reqfield')}
                        </span>
                      ) : !/\S/.test(this.props.DamageErrorlistservice) ? (
                        <span className="rp-warranty-input-error-internal">
                          {i18n.t('partClaim.atleastchar')}
                        </span>
                      ) : this.props.DamageErrorlistservice.length > 250 ? (
                        !commentsRegEx.test(this.props.DamageErrorlistservice) ? (
                          <>
                            <span className="rp-warranty-input-error-internal">
                              {i18n.t('damageClaim.maxeigchar')}
                            </span>
                            <p className="rp-warranty-input-error-internal">
                              {i18n.t('partClaim.tracknumerror')}(
                              {i18n.t('partClaim.noSymbols')})
                            </p>
                          </>
                        ) : (
                          <span className="rp-warranty-input-error-internal">
                            ({i18n.t('damageClaim.maxeigchar')})
                          </span>
                        )
                      ) : (
                        <span className="rp-warranty-input-error-internal">
                          {i18n.t('partClaim.tracknumerror')}(
                          {i18n.t('partClaim.noSymbols')})
                        </span>
                      )
                    ) : (
                      <span className="input-info">
                        <i>
                          {' '}
                          ({i18n.t('damageClaim.maxeigchar')}){''}
                          {i18n.t('partClaim.tracknumerror')}(
                          {i18n.t('partClaim.noSymbols')})
                        </i>{' '}
                      </span>
                    )}
                  </div>
              </div>
          </div>
          
        </div>
      </div>
    );
  }
}

export default ReceivedUsedPartMoreInfo;

interface IReceivedUsedPartMoreInfoProps {
  DamageAdditionalComment: string;
  DamageErrorlistservice: any;
  DamageErrormsgshow: boolean;
  handleAdditionalComment: (event: any) => void;
}
